/**
 * Bearbeitungs-Templates der Container-View — Port von `IwmEditColumnsContainer.razor`.
 * Alle Felder sind Gruppenkennzeichen-Listen der Entität `Container`.
 */

import type { Container } from '@/types/entities';
import { EntityTypes } from '@/types/enums';

import type { CellRenderer, CellTemplateMap } from '../types';
import { GruppenkennzeichenEditor } from './GruppenkennzeichenEditor';

/**
 * `field` ist die Eigenschaft im Modell, `fieldName` der an die API gemeldete Feldname.
 * Bei `NlSp` → `NLSp` und `PoD` → `Pod` weichen beide voneinander ab; die Schreibweise
 * stammt aus dem Altclient und bestimmt den API-Aufruf.
 */
type GruppenkennzeichenField =
  'Anlieferuhrzeit' | 'ContTyp' | 'Empfaenger' | 'NlSp' | 'PoD' | 'Reeder' | 'Spediteur';

function editor(field: GruppenkennzeichenField, fieldName: string): CellRenderer<Container> {
  return (model) => (
    <GruppenkennzeichenEditor
      value={model[field]}
      entity={EntityTypes.Container}
      fieldName={fieldName}
      onCommit={(value) => {
        model[field] = value;
      }}
    />
  );
}

export const containerEditTemplates: CellTemplateMap<Container> = {
  Anlieferuhrzeit: editor('Anlieferuhrzeit', 'Anlieferuhrzeit'),
  ContTyp: editor('ContTyp', 'ContTyp'),
  Empfaenger: editor('Empfaenger', 'Empfaenger'),
  NlSp: editor('NlSp', 'NLSp'),
  PoD: editor('PoD', 'Pod'),
  Reeder: editor('Reeder', 'Reeder'),
  Spediteur: editor('Spediteur', 'Spediteur'),
};

export default containerEditTemplates;
